import { useQuery } from '@tanstack/react-query';
import { fetchItem } from '../services/smr-admin';
import { itemKeys } from './useItemsQuery';

export const useItemQuery = (id?: string) =>
    useQuery({
        queryKey: itemKeys.detail(id ?? ''),
        queryFn: () => fetchItem(id as string),
        enabled: Boolean(id),
    });
